import { IS_UOM_CONVERSION_URL } from "c8-platform";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import reflection from "csi/reflection";
import Nodes from "csi/store/Nodes";
import Path from "csi/table/matrix/Path";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import declare from "dojo/_base/declare";

const REFLECTION_ATTRIBUTE_OWNER = "ReflectionAttributeOwner";

const AttributesMatrix = declare(Path, {
	/** @property {cnl} boUrl - url of the given attribute */
	boUrl: "",

	/** @property {StoreNames} _attributeStore This holds the query for the currentAttribute */
	_attributeStore: null,

	/** @property {string} nameToExclude - name of attribute to exclude in filter */
	nameToExclude: "",

	/** @property {string} reflectionAttributeOwner - name of reflection attribute owner */
	reflectionAttributeOwner: "",

	/** @property {string[]} attributeLimitPaths - list of limit paths to include in the query */
	attributeLimitPaths: [],

	/** 
	 * @override 
	 * Filtering down nodes to BuildInAttribute 
	 */
	addDeferred(ctx: Context, h: Heading, dfds: PromiseLike<any>[]): void {
		const filterQuery = new Query()
			.Attr("Optional", "EQ", true);

		if (this.reflectionAttributeOwner) {
			filterQuery.Attr(REFLECTION_ATTRIBUTE_OWNER, xml.OP_EQUALS, this.reflectionAttributeOwner);
		}

		if (this.boUrl) {
			filterQuery.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, this.boUrl);
		}

		if (this.nameToExclude) {
			// if an attribute had been listed here to exlude it will be added to the filter
			filterQuery.Attr(xml.ATTR_NAME, xml.OP_NOT_EQUALS, this.nameToExclude);
		}

		filterQuery.Or()
			.Node(xml.PROP_TYPE, xml.OP_EQUALS, "BuildInAttribute")
			.Node(xml.PROP_TYPE, xml.OP_EQUALS, "CustomAttribute");

		// hide uom conversion column from optional attributes matrix
		filterQuery.Not().Attr(reflection.ATTR_VALUE, xml.OP_MATCHES, IS_UOM_CONVERSION_URL);

		this._attributeStore = new Nodes({
			cachingStore: ctx.cache,
			filterQuery,
			sortQuery: new Query()
				.SortByAttr("Node Name"),
			typeNode: "ConfigurableAttribute",
			requestParameters: {
				"Qry.Limit.Path": this.attributeLimitPaths,
			},
			bTargetType: true,
		});

		dfds.push(this._attributeStore.query());
	},

	/**
	 * @override
	 * Set index for column to unique value from configured attribute
	 */
	onPathSpecParams(ctx: Context, params: any, columnIndex: number): void {
		params.index = ctx.getNodeAttributeValue(xml.ATTR_NAME, false);
	},

	/** 
	 * @override 
	 * returns the query loaded in addDeffered 
	 */
	_getColumnNodes(ctx: Context, h: Heading): Query {
		return this._attributeStore.query();
	},
});

export = AttributesMatrix;